// ============================================================
// Datei: src/pages/admin/Admin.jsx
// ============================================================

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import "../../styles/global.css";
import "../../styles/ressortTabs.css";

import Api from "../../Api";
import AdminDesktop from "./AdminDesktop";
import AdminMobile from "./AdminMobile";
import useMediaQuery from "../../hooks/useMediaQuery";

const Admin = () => {
	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	const [volunteers, setVolunteers] = useState([]);
	const [shifts, setShifts] = useState([]);
	const [guests, setGuests] = useState([]);
	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [activeTab, setActiveTab] = useState("overview");

	const reloadVolunteers = useCallback(async () => {
		try {
			const res = await Api.get("/volunteers");
			setVolunteers(Array.isArray(res.data) ? res.data : []);
		} catch (err) {
			console.error("❌ Admin: Fehler beim Laden aller Volunteers:", err);
			setVolunteers([]);
		}
	}, []);

	const reloadShifts = useCallback(async () => {
		try {
			const res = await Api.get("/admin/shifts");
			console.log("ADMIN SHIFTS:", res.data);
			setShifts(Array.isArray(res.data) ? res.data : []);
		} catch (err) {
			console.error("❌ Admin: Fehler beim Laden aller Schichten:", err);
			setShifts([]);
		}
	}, []);

	const reloadGuests = useCallback(async () => {
		try {
			const res = await Api.get("/guests");
			setGuests(Array.isArray(res.data) ? res.data : []);
		} catch (err) {
			console.error("❌ Admin: Fehler beim Laden aller Gäste:", err);
			setGuests([]);
		}
	}, []);

	useEffect(() => {
		const role = localStorage.getItem("role");

		if (role !== "ADMIN") {
			alert("Zugriff verweigert!");
			navigate("/home");
			return;
		}

		reloadVolunteers();
		reloadShifts();
		reloadGuests();
	}, [navigate, reloadVolunteers, reloadShifts, reloadGuests]);

	const layoutProps = {
		volunteers,
		setVolunteers,
		reloadVolunteers,
		shifts,
		reloadShifts,
		guests,
		selectedVolunteer,
		setSelectedVolunteer,
		activeTab,
		setActiveTab,
		reloadGuests
	};

	return (
		<div
			className="admin-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_admin.png`}
		>
			<h2 className="admin-heading">Admin</h2>

			{isMobile
				? <AdminMobile {...layoutProps} />
				: <AdminDesktop {...layoutProps} />
			}
		</div>
	);
};

export default Admin;